import { createAction } from 'redux-actions'

export const setAddActionUpdateList = createAction('SET_ADD_ACTION_UPDATE_LIST')
export const setAddTaskModalInitialValue = createAction(
  'SET_ADD_TASK_INITIAL_VALUE'
)
export const setIsAddTaskModalVisible = createAction(
  'SET_IS_ADD_TASK_MODAL_VISIBLE'
)
